import useDebounce from "../../utils/hooks/useDebounce";

export default function useStatsAnalysisSyncViewState(mapProps1, mapProps2) {
  useDebounce(() => {
    const { latitude, longitude, zoom } = mapProps1.viewState;
    if ( latitude && longitude && zoom ) {
      const isChanged = (latitude !== mapProps2.viewState.latitude) ||
                        (longitude !== mapProps2.viewState.longitude) ||
                        (zoom !== mapProps2.viewState.zoom);
      if ( isChanged ) {
        console.log("mapProps2.setMapCenter");
        mapProps2.setMapCenter({ latitude, longitude, zoom });
      }
    }
  }, 500, [mapProps1.viewState, mapProps2.setMapCenter]);

  useDebounce(() => {
    const { latitude, longitude, zoom } = mapProps2.viewState;
    if ( latitude && longitude && zoom ) {
      const isChanged = (latitude !== mapProps1.viewState.latitude) ||
                        (longitude !== mapProps1.viewState.longitude) ||
                        (zoom !== mapProps1.viewState.zoom);
      if ( isChanged ) {
        console.log("mapProps1.setMapCenter");
        mapProps1.setMapCenter({ latitude, longitude, zoom });
      }
    }
  }, 500, [mapProps2.viewState, mapProps1.setMapCenter]);
}
